<template>
    <div>
        <el-dialog
            class="vehicle-info-dialog"
            :before-close="closeDialog"
            title="车辆信息"
            :visible.sync="dialogVisible"
            width="800px">
            <div slot="title">
                <span>车辆信息</span>
                <el-button
                    size="mini"
                    :icon="isSensitive ? 'icon-show' : 'icon-hidden'"
                    @click="handleSensitive"
                ></el-button>
            </div>
            <div>
                <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
                    <el-tab-pane v-for="(item, index) in tabsData" :key="item.licensePlateNo + '_' + index" :label="item.licensePlateNo" :name="item.licensePlateNo"></el-tab-pane>
                </el-tabs>
                <el-form ref="form" label-position="left" label-width="130px">
                    <el-row>
                        <el-col :span="12">
                            <ocr-card-upload
                                :cardTitle="'行驶证正副面'"
                                :flag="
                                    form.carDrivingFileName +
                                    '#' +
                                    form.carDrivingFileTemUrl +
                                    '#' +
                                    form.carDrivingFileId
                                "
                                :imgValue="form.carDrivingFileTemUrl"
                                :disabled="true"
                                @preview="handlePreviewFile" />
                            <el-form-item label="车牌号" prop="licensePlateNo">
                                <el-input
                                    v-model="form.licensePlateNo"
                                    :disabled="true"
                                    placeholder="车牌号"
                                />
                            </el-form-item>
                            <el-form-item label="车辆所有人" prop="carOwner">
                                <el-input :disabled="true" v-model="form.carOwner" placeholder="车辆所有人"></el-input>
                            </el-form-item>
                            <el-form-item v-if="isSensitive" label="车辆所有人手机" prop="_carOwnerPhone">
                                <el-input :disabled="true" v-model="form._carOwnerPhone" placeholder="车辆所有人手机号码"></el-input>
                            </el-form-item>
                            <el-form-item v-else label="车辆所有人手机" prop="carOwnerPhone">
                                <el-input :disabled="true" v-model="form.carOwnerPhone" placeholder="车辆所有人手机号码"></el-input>
                            </el-form-item>
                            <el-form-item label="车型" prop="lengthNameCn">
                                <el-input :disabled="true" v-model="form.lengthNameCn" placeholder="车型"></el-input>
                            </el-form-item>
                            <el-form-item label="总质量（kg）" prop="totalWeight">
                                <el-input :disabled="true" v-model="form.totalWeight" placeholder="请输入车辆总质量（kg）"></el-input>
                            </el-form-item>
                            <el-form-item label="外径宽度(m)" prop="lengthInteriorWidth">
                                <el-input :disabled="true" v-model="form.lengthInteriorWidth" placeholder="车辆外径宽度"></el-input>
                            </el-form-item>
                            <el-form-item label="外径长度(m)" prop="lengthInteriorLength">
                                <el-input :disabled="true" v-model="form.lengthInteriorLength" placeholder="车辆外径长度"></el-input>
                            </el-form-item>
                            <el-form-item label="车辆能源类型" prop="energyType">
                                <m-select
                                    :disabled="true"
                                    :optionNum="'SRM_ENERGY_TYPE'"
                                    :value="form.energyType"
                                ></m-select>
                            </el-form-item>
                            <el-form-item label="车辆常用司机" prop="commonDriver">
                                <el-input :disabled="true" v-model="form.commonDriver" placeholder="车辆常用司机"></el-input>
                            </el-form-item>
                            <el-form-item label="行驶证注册日期" prop="mainRegisterDate">
                                <el-date-picker
                                    :disabled="true"
                                    value-format="yyyy-MM-dd"
                                    v-model="form.mainRegisterDate"
                                    type="date"
                                    :placeholder="'行驶证注册日期'"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="内径长度(m)" prop="insideLength">
                                <el-input :disabled="true" v-model="form.insideLength" placeholder="车辆内径长度"></el-input>
                            </el-form-item>
                            <el-form-item label="内径宽度(m)" prop="insideWidth">
                                <el-input :disabled="true" v-model="form.insideWidth" placeholder="车辆内径宽度"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <ocr-card-upload
                                :cardTitle="'行驶证正副背面'"
                                :flag="
                                    form.carDrivingBottomFileName +
                                    '#' +
                                    form.carDrivingBottomFileTemUrl +
                                    '#' +
                                    form.carDrivingBottomFileId
                                "
                                :imgValue="form.carDrivingBottomFileTemUrl"
                                :disabled="true"
                                @preview="handlePreviewFile" />
                            <el-form-item label="车辆类型" prop="mainVehicleType">
                                <m-select
                                    :disabled="true"
                                    :optionNum="'SRM_VEHICLE_TYPE'"
                                    :value="form.mainVehicleType"
                                ></m-select>
                            </el-form-item>
                            <el-form-item label="整备质量（kg）" prop="grossWeight">
                                <el-input :disabled="true" v-model="form.grossWeight" placeholder="整备质量（kg）"></el-input>
                            </el-form-item>
                            <el-form-item label="核定载重量（kg）" prop="lengthMaxWeight">
                                <el-input :disabled="true" v-model="form.lengthMaxWeight" placeholder="核定载重量"></el-input>
                            </el-form-item>
                            <el-form-item label="车牌颜色" prop="licensePlateColor">
                                <m-select
                                    :disabled="true"
                                    :optionNum="'SRM_LICENSE_PLATE_COLOR'"
                                    :value="form.licensePlateColor"
                                />
                            </el-form-item>
                            <el-form-item label="外径高度(m)" prop="lengthInteriorHeight">
                                <el-input :disabled="true" v-model="form.lengthInteriorHeight" placeholder="车辆外径高度"></el-input>
                            </el-form-item>
                            <el-form-item label="行驶证检验有效期" prop="carDrivingEndTime">
                                <el-date-picker
                                    :disabled="true"
                                    v-model="form.carDrivingEndTime"
                                    type="date"
                                    :placeholder="'行驶证有效期至'"
                                    style="width: 100%"
                                />
                            </el-form-item>
                            <el-form-item label="GPS设备号" prop="deviceNo">
                                <el-input v-model="form.deviceNo" :disabled="true" placeholder="设备号"></el-input>
                            </el-form-item>
                            <el-form-item label="使用性质" prop="mainUserCharacter">
                                <el-input :disabled="true" v-model="form.mainUserCharacter" placeholder="使用性质"></el-input>
                            </el-form-item>
                            <el-form-item label="行驶证发证日期" prop="mainIssueDate">
                                <el-date-picker
                                    :disabled="true"
                                    value-format="yyyy-MM-dd"
                                    v-model="form.mainIssueDate"
                                    type="date"
                                    :placeholder="'行驶证发证日期'"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="行驶证发证机关" prop="carDrivingAuthority">
                                <el-input :disabled="true" v-model="form.carDrivingAuthority" placeholder="行驶证发证机关"></el-input>
                            </el-form-item>
                            <el-form-item label="车辆识别代码" prop="mainVin">
                                <el-input :disabled="true" v-model="form.mainVin" placeholder="车辆识别代码"></el-input>
                            </el-form-item>
                            <el-form-item label="内径高度(m)" prop="insideHeight">
                                <el-input :disabled="true" v-model="form.insideHeight" placeholder="车辆内径高度"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDialog">关闭</el-button>
            </span>
        </el-dialog>

        <preview
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"></preview>
    </div>
</template>

<script>
import { getVehicleInfo } from '../../../../api/driverAddSupplier.js'
import common from '../../../../api/common.js';
import OcrCardUpload from '../../../../components/ocrCardUpload/Index.vue'
import preview from '../../../../components/viewAttachment.vue'
import mSelect from '../../../../components/Select.vue';
import { getSensitiveVal } from '../../../../utils/common.js'

const INIT_FORM = {
    carDrivingFileId: '',
    carDrivingFileName: '',
    carDrivingFileUrl: '',
    carDrivingFileTemUrl: '',
    licensePlateNo: '',
    carOwner: '',
    carOwnerPhone: '',
    _carOwnerPhone: '', // 脱敏后的车辆所有人手机
    lengthNameCn: '',
    totalWeight: '',
    lengthInteriorWidth: '',
    lengthInteriorLength: '',
    energyType: '',
    commonDriver: '',
    mainRegisterDate: '',
    insideLength: '',
    insideWidth: '',
    carDrivingBottomFileId: '',
    carDrivingBottomFileName: '',
    carDrivingBottomFileUrl: '',
    carDrivingBottomFileTemUrl: '',
    mainVehicleType: '',
    grossWeight: '',
    lengthMaxWeight: '',
    licensePlateColor: '',
    lengthInteriorHeight: '',
    carDrivingEndTime: '',
    deviceNo: '',
    mainUserCharacter: '',
    mainIssueDate: '',
    carDrivingAuthority: '',
    mainVin: '',
    insideHeight: '',
}

export default {
    props: ['dialogVisible', 'applyCode'],
    components: { OcrCardUpload, preview, mSelect },
    data() {
        return {
            attachmentShow: false,
            rowData: {},
            form: {
                // idCardFrontFileName: 'haha',
                // idCardFrontFileId: '1',
                // idCardFrontFileUrl:
                //     'https://oss-cn-uat.midea.com/c-ztb/uat/default/20240506/1714976051448_daf430df-0b6f-11ef-a46a-0cda411d44b3.png',
                ...INIT_FORM,
            },
            activeName: null,
            tabsData: [],
            isSensitive: true
        }
    },
    methods: {
        handlePreviewFile(obj) {
            this.rowData.downUrl = obj
            this.attachmentShow = true
        },
        closeDialog() {
            this.clear()
            this.$emit('update:dialogVisible', false)
        },
        load() {
            getVehicleInfo(this.applyCode).then(res => {
                if (res && +res.code === 0) {
                    // this.form = res.data[0]
                    if (res.data && res.data.length) {
                        this.tabsData = res.data
                        this.activeName = this.tabsData[0].licensePlateNo
                        this.setForm(this.tabsData[0])
                    } else {
                        this.tabsData = []
                        this.activeName = null
                    }
                }
            })
        },
        handleTabClick(val) {
            const tabData = this.tabsData.find(item => item.licensePlateNo === val.name)
            this.setForm(tabData)
        },
        setForm(data) {
            Object.keys(this.form).forEach(key => {
                if (key === '_carOwnerPhone') {
                    this.form._carOwnerPhone = data.carOwnerPhone ? getSensitiveVal(data.carOwnerPhone, 'phone') : ''
                } else {
                    this.form[key] = data[key]
                }
            })
        },
        clear() {
            this.form = { ...INIT_FORM }
            this.rowData = {}
            this.activeName = null
            this.tabsData = []
            this.isSensitive = true
        },
        handleSensitive() {
            this.isSensitive = !this.isSensitive;
            if (!this.isSensitive) {
                common.operationRecord({ operationModule: `司机加入供应商申请-车辆` });
            }
        },
    },
    watch: {
        dialogVisible(val) {
            if (val) {
                this.load()
            } else {
                this.clear()
            }
        }
    }
}
</script>
<style lang="less" >
.vehicle-info-dialog {
    .el-dialog__header .el-button {
        margin-left: 10px;
    }

    .box-card {
        margin-bottom: 22px;
    }

    .ocr-upload .ocr-upload-container {
        height: 170px;
    }

    .el-col {
        padding-right: 15px !important;
        padding-left: 15px !important;
    }

    .el-form-item__label,
    .el-form-item__content {
        line-height: 28px;
    }
}
</style>
